<template>
  <v-dialog v-model="value" max-width="300px" :persistent="persistent">
    <v-card class="pa-5">
      <v-card-title  class="pa-0 mb-3" style="display: flex; align-items: center; justify-content: space-between;">
          <slot name="title">
            <span style="font-weight: bold; font-size: 24px;">
              <slot></slot>
            </span>
          </slot>

        <slot name="close"></slot>
      </v-card-title>
      

      <v-card-text class="pa-0 mb-3">
        <slot name="content">

        </slot>
      </v-card-text>

      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <!-- <slot name="actions">
          <v-btn depressed dark class="mb-2" @click="defaultAction">Test</v-btn>
        </slot> -->

        <slot name="actions">
          <TextButtonBlock :buttonText="$store.getters.t('취소')"/>
          <TextButtonBlock :buttonText="$store.getters.t('삭제')"/>
        </slot>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    persistent: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
    };
  },
  methods: {
    openDialog() {
    },
    closeDialog() {
      this.$emit('input', false);
    },
    defaultAction() {
      this.closeDialog();
    }
  }
}
</script>

<style lang="scss" scoped></style>